<div class="report-card shadow-sm">
    <div class="report-card__content">
        <div class="report-card__details">
            <div class="report-card__icon" aria-hidden="true">
                <img [src]="'assets/images/icons/home/' + icon" [alt]="title" class="report-card__img-icon" />
            </div>

            <div class="report-card__copy">
                <h5 class="report-card__title mb-0">{{ title }}</h5>
            </div>
        </div>

        <div class="d-flex align-items-center" style="gap:10px;">
            <a class="icon-action report-card__action" (click)="emitAction($event)" (keydown.enter)="emitAction($event)"
                (keydown.space)="emitAction($event)" [attr.aria-label]="tooltip" role="button" tabindex="0">
                <i data-feather="download" class="text-primary feather-icon"></i>
            </a>
        </div>
    </div>
</div>